import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderHistoryAttributeState } from "@tKgpco/Store/Data/OrderHistory/OrderHistoryAttributeState";
import { Draft } from "immer";

const initialState: OrderHistoryAttributeState = {
    isLoading: false,
    orderAttributeCollection: null,
};
export const reducer = {
    "Custom/OrderDetailAttribute/BeginLoad": (draft: Draft<OrderHistoryAttributeState>) => {
        draft.isLoading = true;
    },
    "Custom/OrderDetailAttribute/CompleteLoad": (
        draft: Draft<OrderHistoryAttributeState>,
        action: OrderHistoryAttributeState,
    ) => {
        draft.isLoading = false;
        draft.orderAttributeCollection = action.orderAttributeCollection;
    },
    "Custom/OrderDetailAttribute/FailedToLoadAccessorials": (draft: Draft<OrderHistoryAttributeState>) => {
        draft.isLoading = false;
        draft.orderAttributeCollection = null;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
